/**
 * Narrow an unknown value to a member of a string enum, returning `undefined`
 * if it doesn't match. Useful for safely consuming string fields from the API
 * that should be one of a known enum.
 */
export const parseEnum = <T extends Record<string, string>>(
  enumObj: T,
  value: unknown,
): T[keyof T] | undefined =>
  typeof value === "string" && (Object.values(enumObj) as string[]).includes(value)
    ? (value as T[keyof T])
    : undefined;
